/**
 * Durable on-device journal of the in-progress playback session's unreported listening.
 * Lets a session that crashed without a clean end be recovered and counted on next app boot.
 * Single responsibility: persist / load / clear ONE session snapshot via local-save.
 */
import localSave from '@utils/local-save'
import { STORAGE_KEYS } from './analytics-spec'

export function saveJournal(snapshot) {
    return localSave.save(STORAGE_KEYS.PLAYBACK_JOURNAL, snapshot)
}
export function loadJournal() {
    return localSave.get(STORAGE_KEYS.PLAYBACK_JOURNAL)
}
export function clearJournal() {
    return localSave.delete(STORAGE_KEYS.PLAYBACK_JOURNAL)
}

export default { saveJournal, loadJournal, clearJournal }
